import { DefaultService } from '@/services/DefaultService';

export default class GradecolunaService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

	
}